import React, { useEffect } from 'react';
import { Box, Button, Grid } from '@mui/material';
import './ModalFooter.css';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { GET_SAVED_WAN_PROFILE_DATA } from '../../../../../actions/types';

interface ModalFooterProps {
  onClose: () => void;
  onSave: () => void;
  cancelText?: string;
  saveText?: string;
  disableSave?: boolean;
  getSavedWanProfileData: any;
  showCancel?: boolean;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  onClose,
  onSave,
  cancelText = 'Cancel',
  saveText = 'Save',
  disableSave = false,
  getSavedWanProfileData,
  showCancel = true
}) => {

  const dispatch = useDispatch();
  useEffect(() => {
    if (getSavedWanProfileData?.data?.hasOwnProperty('status')) {
      const timer = setTimeout(() => {
        dispatch({ type: GET_SAVED_WAN_PROFILE_DATA, payload: {} });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [getSavedWanProfileData]);

  return (
    <Box className="modal-footer">
      <span style={getSavedWanProfileData?.data?.status ? { color: '#2bb006' } : { color: 'red' }}>{getSavedWanProfileData?.data?.hasOwnProperty('status') && getSavedWanProfileData?.data?.msg}</span>
      <Grid>
        {showCancel && <Button onClick={onClose} className="cancel-button-inventory">
          {cancelText}
        </Button>}
        <Button
          onClick={onSave}
          className="ok-button"
          variant="contained"
          disabled={disableSave}
          style={{ backgroundColor: disableSave ? "#ccc" : "#1B51A7", color: disableSave ? "#666" : "#fff" }}
        >
          {saveText}
        </Button>
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  getSavedWanProfileData: state.authReducer.getSavedWanProfileData,
});

export default withRouter(
  connect(mapStateToProps, {})(ModalFooter)
)
